import { Typography } from '@mui/material';
import { useLocale } from '@jd/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

type Props = {
  publishedAt?: string;
};

const PublishedDate = ({ publishedAt }: Props) => {
  const locale = useLocale();
  if (!publishedAt) return null;
  return (
    <Typography
      component={'time'}
      dateTime={publishedAt}
      variant={'body2'}
      sx={{ color: 'text.secondary', display: 'block' }}
    >
      {dayjs(publishedAt).locale(locale).format('D MMMM YYYY')}
    </Typography>
  );
};

export default PublishedDate;
